import contact from '@/assets/images/help/contact.png';
import map from '@/assets/images/help/map.png';
import operator from '@/assets/images/help/operator.png';
import GlobalDivider from '@/utils/divider/GlobalDivider';
import { Card, Col, Row, Typography } from 'antd';

const { Text } = Typography;

const HelpComponents = () => {
  const cardData = [
    {
      key: 1,
      image: contact,
      title: 'Company',
      Number: '+977 9800000000',
    },
    {
      key: 2,
      image: operator,
      title: 'Customer Care',
      Number: '+977 9800000000',
    },
    {
      key: 3,
      image: map,
      title: 'Company Location',
      Number: 'Sunrise Chowk Pepsicola',
    },
  ];

  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <GlobalDivider name="Help and Support" orientation="center" />
      <Row></Row>

      <Row gutter={[16, 16]} justify="center">
        {cardData.map((item) => (
          <Col key={item.key} xs={24} sm={12}>
            <Card
              style={{
                // display: 'flex',
                // alignItems: 'center',
                padding: '15px',
                borderRadius: '10px',
                boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
              }}
            >
              <img
                src={item.image}
                alt={item.title}
                style={{ width: 32, height: 32, marginRight: 12 }}
              />
              <div>
                <Text strong>{item.title}</Text>
                <br />
                <Text>{item.Number}</Text>
              </div>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default HelpComponents;
